import { useSearchParams } from 'react-router-dom';

export const useSetSearchParamsValue = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (name: string, value: string | number) => {
    searchParams.set(name, JSON.stringify(value));
    setSearchParams(searchParams);
  };
};
